import { Icon } from '@iconify/react';

interface FeatureItemProps {
  text: string;
}

const FeatureItem = ({ text }: FeatureItemProps) => (
  <div className="flex items-center gap-2">
    <Icon
      icon="solar:check-circle-bold"
      className="text-green-500"
      width={'17px'}
      height="17px"
    />
    <span>{text}</span>
  </div>
);

const Features = () => {
  const featureList = [
    'Performance Acceleration',
    'Leadership Development',
    'Organizational Transformation',
  ];

  return (
    <div className="md:mb-12 flex gap-8 mb-0 text-sm overflow-auto">
      {featureList.map((feature, index) => (
        <FeatureItem key={index} text={feature} />
      ))}
    </div>
  );
};

export default Features;
